import Application from "../../Application";
import ReportingPeriodPermissionPresenter, {
  IReportingPeriodPermissionPresenter
} from "../../presenter/reporting/ReportingPeriodPermissionPresenter";
import GetReportingPeriodPermissionsInteractor from "./GetReportingPeriodPermissionsInteractor";
import GetAuthorizedOperatorsInteractor from "./GetAuthorizedOperatorsInteractor";

export default class ShowReportingPeriodPermissionsInteractor {
  private application: Application;
  private output?: IReportingPeriodPermissionPresenter;

  constructor(application) {
    this.application = application;
  }

  async getReportingPeriodPermissions(
    applicantReportingPeriodId: number,
    applicantId: number
  ) {
    return this.application.container
      .resolve<GetReportingPeriodPermissionsInteractor>(
        "getReportingPeriodPermissions"
      )
      .execute(applicantId, applicantReportingPeriodId);
  }

  async getAuthorizedOperators(applicantReportingPeriodId: number) {
    return this.application.container
      .resolve<GetAuthorizedOperatorsInteractor>("getAuthorizedOperators")
      .execute(applicantReportingPeriodId);
  }

  execute(reportingPeriodId: number, applicantId: number) {
    this.output = ReportingPeriodPermissionPresenter({
      application: this.application,
      initialState: {
        reportingPeriodPermissions: [],
        users: [],
        applicantId,
        reportingPeriodId
      },
      topic: reportingPeriodId.toString().toLowerCase()
    });

    this.getAuthorizedOperators(reportingPeriodId).then(
      staff => this.output && this.output.setUsers(staff)
    );

    this.getReportingPeriodPermissions(reportingPeriodId, applicantId).then(
      reportingPeriodPermissions =>
        this.output &&
        this.output.setReportingPeriodPermissions(reportingPeriodPermissions)
    );
    return this.output;
  }
}
